import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
const OneThroughTwelve = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const ZeroThroughTwelve = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const propTypes = {
  span: PropTypes.oneOf(OneThroughTwelve).isRequired,
  spanXs: PropTypes.oneOf(OneThroughTwelve),
  spanSm: PropTypes.oneOf(OneThroughTwelve),
  spanMd: PropTypes.oneOf(OneThroughTwelve),
  spanLg: PropTypes.oneOf(OneThroughTwelve),
  spanXl: PropTypes.oneOf(OneThroughTwelve),
  offset: PropTypes.oneOf(ZeroThroughTwelve),
  offsetSm: PropTypes.oneOf(ZeroThroughTwelve),
  offsetMd: PropTypes.oneOf(ZeroThroughTwelve),
  offsetLg: PropTypes.oneOf(ZeroThroughTwelve),
  offsetXl: PropTypes.oneOf(ZeroThroughTwelve),
  push: PropTypes.oneOf(ZeroThroughTwelve),
  pushSm: PropTypes.oneOf(ZeroThroughTwelve),
  pushMd: PropTypes.oneOf(ZeroThroughTwelve),
  pushLg: PropTypes.oneOf(ZeroThroughTwelve),
  pushXl: PropTypes.oneOf(ZeroThroughTwelve),
  pull: PropTypes.oneOf(ZeroThroughTwelve),
  pullSm: PropTypes.oneOf(ZeroThroughTwelve),
  pullMd: PropTypes.oneOf(ZeroThroughTwelve),
  pullLg: PropTypes.oneOf(ZeroThroughTwelve),
  pullXl: PropTypes.oneOf(ZeroThroughTwelve),
  flexColumn: PropTypes.bool,
  verticallyCenterContent: PropTypes.bool,
  sticky: PropTypes.bool,
  unsticky: PropTypes.oneOf(['none', 'xs']),
  floatingContainer: PropTypes.bool,
  floatingContainerAlignment: PropTypes.oneOf(['left', 'right'])
};
const Column = createComponent({
  displayName: 'Column',
  root: 'div',
  propTypes,
  propConfig: {
    classNames(props) {
      const {
        span,
        spanXs,
        spanSm,
        spanMd,
        spanLg,
        spanXl,
        offset,
        offsetSm,
        offsetMd,
        offsetLg,
        offsetXl,
        push,
        pushSm,
        pushMd,
        pushLg,
        pushXl,
        pull,
        pullSm,
        pullMd,
        pullLg,
        pullXl,
        flexColumn = false,
        verticallyCenterContent = false,
        sticky = false,
        unsticky = 'none',
        floatingContainer = false,
        floatingContainerAlignment = 'left'
      } = props;
      const classNameSet = new Set(["swan-col-".concat(span)]);
      if (spanXs !== undefined) classNameSet.add("swan-col-xs-".concat(spanXs));
      if (spanSm !== undefined) classNameSet.add("swan-col-sm-".concat(spanSm));
      if (spanMd !== undefined) classNameSet.add("swan-col-md-".concat(spanMd));
      if (spanLg !== undefined) classNameSet.add("swan-col-lg-".concat(spanLg));
      if (spanXl !== undefined) classNameSet.add("swan-col-xl-".concat(spanXl));
      if (offset !== undefined) classNameSet.add("swan-col-offset-".concat(offset));
      if (offsetSm !== undefined) classNameSet.add("swan-col-sm-offset-".concat(offsetSm));
      if (offsetMd !== undefined) classNameSet.add("swan-col-md-offset-".concat(offsetMd));
      if (offsetLg !== undefined) classNameSet.add("swan-col-lg-offset-".concat(offsetLg));
      if (offsetXl !== undefined) classNameSet.add("swan-col-xl-offset-".concat(offsetXl));
      if (pull !== undefined) classNameSet.add("swan-col-pull-".concat(pull));
      if (pullSm !== undefined) classNameSet.add("swan-col-sm-pull-".concat(pullSm));
      if (pullMd !== undefined) classNameSet.add("swan-col-md-pull-".concat(pullMd));
      if (pullLg !== undefined) classNameSet.add("swan-col-lg-pull-".concat(pullLg));
      if (pullXl !== undefined) classNameSet.add("swan-col-xl-pull-".concat(pullXl));
      if (push !== undefined) classNameSet.add("swan-col-push-".concat(push));
      if (pushSm !== undefined) classNameSet.add("swan-col-sm-push-".concat(pushSm));
      if (pushMd !== undefined) classNameSet.add("swan-col-md-push-".concat(pushMd));
      if (pushLg !== undefined) classNameSet.add("swan-col-lg-push-".concat(pushLg));
      if (pushXl !== undefined) classNameSet.add("swan-col-xl-push-".concat(pushXl));
      if (flexColumn) classNameSet.add('swan-col-flex-column');
      if (verticallyCenterContent) classNameSet.add('swan-col-vertically-center');
      if (sticky) classNameSet.add('swan-col-sticky');
      if (unsticky === 'xs') classNameSet.add('swan-col-unsticky-xs');
      if (floatingContainer) classNameSet.add('swan-floating-container');
      if (floatingContainerAlignment === 'right') classNameSet.add('swan-floating-container-right');
      return classNameSet;
    }
  }
});
export { Column };